/*
    © 2023 NetSuite Inc.
    User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
    provided, however, if you are an authorized user with a NetSuite account or log-in, you
    may use this code subject to the terms that govern your access and use.
*/
define('CoreCharge.List.View', [
    'SCView',
    'core_charge_list.tpl',
    'CoreCharge.Model'
], function CoreChargeListViewModule(
    SCViewComponent,
    template,
    CoreChargeModel
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function CoreChargeListView(options) {
        var self = this;
        SCView.call(this);
        this.title = options.title;
        this.config = options.config;
        this.options = options || {};
        this.template = template;
        this.model = new CoreChargeModel();
        this.model.fetch().then(function then(data) {
            self.otherCharges = data;
            self.render();
        });
    }

    // Inherit parent instance methods.
    CoreChargeListView.prototype = Object.create(SCView.prototype);


    // Restore the constuctor.
    CoreChargeListView.prototype.constructor = CoreChargeListView;

    CoreChargeListView.prototype.getContext = function getContext() {
        return {
            title: this.title,
            list: this.otherCharges,
            showList: this.otherCharges && !this.otherCharges.error && this.otherCharges.length > 0
        };
    };

    // Return the AMD constructor.
    return CoreChargeListView;
});
